// extracted by mini-css-extract-plugin
export var emptyState = "_6t-d";
export var statCard = "_6t-c";
export var table = "_6t-0";
export var tableCell = "_6t-4";
export var tableCellClickable = "_6t-5 _6t-4";
export var tableCellDefault = "_6t-6 _6t-4";
export var tableCellEmpty = "_6t-8";
export var tableCellWithValue = "_6t-7";
export var tableContainer = "_6t-e";
export var tableHeaderWeight = "_6t-1";
export var tableHeaderZone = "_6t-2";
export var tableRowHeader = "_6t-3";
export var viewModeButton = "_6t-9";
export var viewModeButtonActive = "_6t-a _6t-9";
export var viewModeButtonInactive = "_6t-b _6t-9";